/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ICopySettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.CopyWorkflowBlock;
        isReadonly: boolean;
        processSchemaProperties: Wars.Domain.Model.SchemaProperty[];
        processActions: Wars.Domain.Model.ProcessAction[];
        processConfigId: string;

        listPropertySchemaProperty: Wars.Domain.Model.SchemaProperty;
        propertyToUpdateSchemaProperty: Wars.Domain.Model.SchemaProperty;
        relatedProcessSchemaProperty: Wars.Domain.Model.SchemaProperty;

        updateSchemaPropertyIds: () => void;

        onListPropertyDragOver: ($event: any) => void;
        onListPropertyDrop: ($event: any) => void;

        onPropertyToUpdateDragOver: ($event: any) => void;
        onPropertyToUpdateDrop: ($event: any) => void;
    }

    export class CopySettingsModalController extends BaseModalController {
        scope: ICopySettingsModalControllerScope;

        constructor(
            $scope: ICopySettingsModalControllerScope,
            workflowBlock: models.CopyWorkflowBlock,
            processConfigId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private processActionService: services.ProcessActionService,
            private treeService: services.TreeService,
            private schemaPropertyService: services.SchemaPropertyService,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;
            
            this.scope.updateSchemaPropertyIds = () => this.updateSchemaPropertyIds();

            this.scope.onListPropertyDragOver = ($event: any) => { };
            this.scope.onListPropertyDrop = ($event: any) => this.onListPropertyDrop($event);

            this.scope.onPropertyToUpdateDragOver = ($event: any) => { };
            this.scope.onPropertyToUpdateDrop = ($event: any) => this.onPropertyToUpdateDrop($event);

            this.initialize();
        }

        private initialize(): void {
            this.processConfigurationService.getProcessSchemaProperties(this.scope.processConfigId).then(
                (schemaProperties) => {
                    this.scope.processSchemaProperties = schemaProperties;
                });

            this.processActionService.getAllProcessActions(this.scope.processConfigId).then(
                (processActions) => {
                    this.scope.processActions = processActions;
                });

            this.hydrateSchemProperties();
        }

        private hydrateSchemProperties(): void {
            if (this.scope.workflowBlock.copyDto.listPropertySchemaPropertyId) {
                this.schemaPropertyService.getSchemaProperty(this.scope.workflowBlock.copyDto.listPropertySchemaPropertyId).then(
                (schemaProperty) => {
                    this.scope.listPropertySchemaProperty = schemaProperty;
                });
            }

            if (this.scope.workflowBlock.copyDto.propertyToUpdateSchemaPropertyId) {
                this.schemaPropertyService.getSchemaProperty(this.scope.workflowBlock.copyDto.propertyToUpdateSchemaPropertyId).then(
                    (schemaProperty) => {
                        this.scope.propertyToUpdateSchemaProperty = schemaProperty;
                    });
            }

            if (this.scope.workflowBlock.copyDto.relatedProcessSchemaPropertyId) {
                this.schemaPropertyService.getSchemaProperty(this.scope.workflowBlock.copyDto.relatedProcessSchemaPropertyId).then(
                    (schemaProperty) => {
                        this.scope.relatedProcessSchemaProperty = schemaProperty;
                    });
            }
        }

        private updateSchemaPropertyIds() : void {
            this.scope.workflowBlock.copyDto.listPropertySchemaPropertyId = this.scope.listPropertySchemaProperty
                ? this.scope.listPropertySchemaProperty.id
                : null;

            this.scope.workflowBlock.copyDto.propertyToUpdateSchemaPropertyId = this.scope.propertyToUpdateSchemaProperty
                ? this.scope.propertyToUpdateSchemaProperty.id
                : null;

            this.scope.workflowBlock.copyDto.relatedProcessSchemaPropertyId = this.scope.relatedProcessSchemaProperty
                ? this.scope.relatedProcessSchemaProperty.id
                : null;
        }

        private onListPropertyDrop($event: any) :void {
            var treeConfig = this.treeService.getTreeConfigurationItem();

            this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                (schemaProperty) => {
                    this.scope.listPropertySchemaProperty = schemaProperty;

                    $event.preventDefault();
                    $event.stopPropagation();

                    this.treeService.clearDragValue();

                    this.scope.updateSchemaPropertyIds();

                });
        }

        private onPropertyToUpdateDrop($event: any) :void  {
            var treeConfig = this.treeService.getTreeConfigurationItem();

            this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                (schemaProperty) => {
                    this.scope.propertyToUpdateSchemaProperty = schemaProperty;

                    $event.preventDefault();
                    $event.stopPropagation();

                    this.treeService.clearDragValue();

                    this.scope.updateSchemaPropertyIds();
                });
        }
    }
}

warsApp.registerController('CopySettingsModalController',
    ['$scope', 'workflowBlock', 'processConfigId', "processConfigurationService", "processActionService", "treeService", "schemaPropertyService", 'isReadonly', 'close']);